import '../styles/WelcomeStyle.css';

export default function Welcome() {
  return (
    <div className="welcome">
      <div className="welcome-container">
        <div className="welcome-a">
          <h1>Welcome to Destroyer</h1>
        </div>
        <div className="welcome-b">
          A quick explanation of how this this works
        </div>
        <div className="welcome-c"></div>
        <div className="welcome-d"></div>
        <div className="welcome-e">Privacy Policy</div>
        <div className="welcome-f"></div>
      </div>
    </div>
  );
}
